import Vue from 'vue'
import 'weui'
import App from './App.vue'
import router from './route/router'
import store from './store/index.js'
// 自定义指令引入
import './utils/directive'

import wx from 'weixin-js-sdk'
import viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
import {
  Dialog,
  Button,
  Cell,
  CellGroup,
  Checkbox,
  ActionSheet,
  RadioGroup,
  Radio,
  Form,
  Field,
  Uploader,
  Icon,
  Swipe,
  SwipeItem,
  Tag,
  Image as VanImage,
  PasswordInput,
  Popup,
  DatetimePicker,
  Collapse,
  CollapseItem,
  Divider,
  Loading,
  Tab, Tabs
} from 'vant'
global.wx = wx

Vue.use(Dialog)
Vue.use(Button)
Vue.use(Checkbox)
Vue.use(Cell)
Vue.use(CellGroup)
Vue.use(ActionSheet)
Vue.use(Field)
Vue.use(Form)
Vue.use(Uploader)
Vue.use(Icon)
Vue.use(Swipe)
Vue.use(SwipeItem)
Vue.use(Tag)
Vue.use(VanImage)
Vue.use(PasswordInput)
Vue.use(RadioGroup)
Vue.use(Radio)
Vue.use(Popup)
Vue.use(DatetimePicker)
Vue.use(Collapse)
Vue.use(CollapseItem)
Vue.use(Divider)
Vue.use(Loading)
Vue.use(viewer)
Vue.use(Tab)
Vue.use(Tabs)
Vue.config.productionTip = false
Vue.config.ignoredElements = ['wx-open-launch-weapp', 'wx-open-subscribe']
new Vue({
  router,
  store,
  viewer,
  render: h => h(App)
}).$mount('#app')
